import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ReadingTime {
	constructor(el, container) {
		// DOM elements
		this.el = el;
		this.container = container;
		this.target = this.el.dataset.readingTime;

		if (!this.target) {
			return;
		}

		// ScrollTrigger
		this.scrollTrigger = new ScrollTrigger({
			trigger: this.target,
			start: 'top bottom',
			end: () => {
				return `+=${this.container.querySelector(this.target).offsetHeight + 40}`;
			},
			onUpdate: (self) => {
				this.el.style.setProperty('--p', `${self.progress * 100}%`);
			},
		});
	}

	destroy() {
		this.scrollTrigger.kill();
		this.scrollTrigger = null;
	}
}
